// VIB-642: Hjelpefunksjon for å wrappe kritiske flyter i Sentry performance spans.
//
// Brukes til å instrumentere auth, DB-mutasjoner og andre kritiske operasjoner
// så Sentry Performance viser hvor mye tid de tar (og hvor de feiler). Spans
// rapporteres automatisk inn under den aktive transaksjonen via browserTracing.

import { Sentry } from "./sentry";

/** Tillatte op-typer for våre spans. Holder lista stram så Sentry-dashboardet
 * grupperer riktig (i stedet for å bli flooded av ad hoc-strenger).
 *
 * - `auth` — innlogging, signup, passordbytte
 * - `db.query` — SELECT mot Supabase
 * - `db.mutation` — INSERT/UPDATE/DELETE mot Supabase
 * - `http` — fetch mot edge functions eller eksterne APIer
 * - `ui.render` — tunge React-renders (lite brukt foreløpig)
 */
export type SpanOp = "auth" | "db.query" | "db.mutation" | "http" | "ui.render";

/**
 * Wrap en async-operasjon i et Sentry span. Returnerer det fn returnerer.
 * Feil propageres som vanlig — spannet markeres som feilet automatisk av
 * Sentry.startSpan hvis fn kaster.
 */
export async function traceSpan<T>(
  name: string,
  op: SpanOp,
  fn: () => Promise<T>,
): Promise<T> {
  return Sentry.startSpan({ name, op }, fn);
}
